import { render } from "./NoteTypeList.vue?vue&type=template&id=65da60dd"
import script from "./NoteTypeList.vue?vue&type=script&lang=js"
export * from "./NoteTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__